import ls from 'localstorage-slim';

const STORAGE_KEY = 'freeSpinsProgress';

/**
 * Persisted reveal progress of an in-flight free spins round. It is written as
 * each free spin starts so that a page refresh can resume the same step instead
 * of replaying the whole feature from the trigger.
 */
export type FreeSpinsProgress = {
    /** Round the progress belongs to; progress from any other round is stale. */
    betID: number;
    /** Index into `round.state` of the current free spin's `updateFreeSpin`. */
    resumeIndex: number;
};

export function saveFreeSpinsProgress(progress: FreeSpinsProgress): void {
    ls.set(STORAGE_KEY, progress);
}

export function getFreeSpinsProgress(): FreeSpinsProgress | null {
    return ls.get<FreeSpinsProgress>(STORAGE_KEY) ?? null;
}

export function clearFreeSpinsProgress(): void {
    ls.remove(STORAGE_KEY);
}
